import { QUERY_KEYS } from 'api/query-keys';
import { partnerInboxService } from 'partner/shared/services';
import { useMutation, useQueryClient } from 'react-query';

type ResolveMessageTaskParams = {
  messageId: string;
};

export const useResolveMessageTask = () => {
  const mutationFn = async ({ messageId }: ResolveMessageTaskParams) =>
    await partnerInboxService.resolveInboxMessageTask(messageId);
  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.inbox());
    },
  });
};
